// ---- Times

export const ONE_SEC_IN_MS = 1000;
export const ONE_MIN_IN_MS = ONE_SEC_IN_MS * 60;
export const ONE_HOUR_IN_MS = ONE_MIN_IN_MS * 60;
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;
